// extracted by css-extract-rspack-plugin
export default {"FileInputText":"FileInput-module__FileInputText___rVgQz"};